import { Prescription, PrescriptionDetail } from '../../types';
import { delay } from '../mock/delay';
import { mockPrescriptions, mockPrescriptionDetails } from '../mock/prescriptions';

export const prescriptionService = {
  getList: async (filters?: {
    code?: string;
    patientName?: string;
    doctorName?: string;
    startDate?: string;
    endDate?: string;
  }): Promise<Prescription[]> => {
    await delay(500);
    let filtered = [...mockPrescriptions];
    
    if (filters?.code) {
      filtered = filtered.filter((p) => p.code.includes(filters.code!));
    }
    if (filters?.patientName) {
      filtered = filtered.filter((p) => p.patientName.includes(filters.patientName!));
    }
    if (filters?.doctorName) {
      filtered = filtered.filter((p) => p.doctorName.includes(filters.doctorName!));
    }
    if (filters?.startDate) {
      filtered = filtered.filter((p) => p.createdAt >= filters.startDate!);
    }
    if (filters?.endDate) {
      filtered = filtered.filter((p) => p.createdAt <= filters.endDate!);
    }
    
    return filtered;
  },

  getDetail: async (code: string): Promise<PrescriptionDetail> => {
    await delay(300);
    const detail = mockPrescriptionDetails[code];
    if (!detail) {
      throw new Error('Prescription not found');
    }
    return detail;
  },

  sendToNational: async (ids: string[]): Promise<void> => {
    await delay(1000);
    ids.forEach((id) => {
      const prescription = mockPrescriptions.find((p) => p.id === id);
      if (prescription) {
        prescription.status = 'sent';
      }
    });
  },

  exportInvoice: async (ids: string[]): Promise<void> => {
    await delay(1000);
    ids.forEach((id) => {
      const prescription = mockPrescriptions.find((p) => p.id === id);
      if (prescription) {
        prescription.invoiceStatus = 'exported';
      }
    });
  },

  getNationalPrescriptions: async (filters?: {
    code?: string;
    patientName?: string;
    doctorName?: string;
    startDate?: string;
    endDate?: string;
  }): Promise<Prescription[]> => {
    await delay(500);
    // Chỉ lấy các đơn đã được gửi lên hệ thống quốc gia
    let filtered = mockPrescriptions.filter((p) => p.status === 'sent' && p.sentDate);
    
    if (filters?.code) {
      filtered = filtered.filter((p) => p.code.includes(filters.code!));
    }
    if (filters?.patientName) {
      filtered = filtered.filter((p) => p.patientName.includes(filters.patientName!));
    }
    if (filters?.doctorName) {
      filtered = filtered.filter((p) => p.doctorName.includes(filters.doctorName!));
    }
    if (filters?.startDate) {
      filtered = filtered.filter((p) => p.createdAt >= filters.startDate!);
    }
    if (filters?.endDate) {
      filtered = filtered.filter((p) => p.createdAt <= filters.endDate!);
    }
    
    return filtered;
  },
};

